import {
  createContext,
  useContext,
  useMemo,
  useState,
  useCallback,
  useEffect
} from "react";

import NotificationCenter
  from "./NotificationCenter";

import VexaDialogHost
  from "./VexaDialogHost";

const NotificationContext =
  createContext(null);

export function NotificationProvider({

  children

}) {

  const [

    notifications,

    setNotifications

  ] = useState([]);

  const removeNotification =
    useCallback(id => {

      setNotifications(prev =>

        prev.filter(

          notification =>

            notification.id !== id

        )

      );

    }, []);

  const clearNotifications =
    useCallback(() => {

      setNotifications([]);

    }, []);

  const notify =
    useCallback(notification => {

      const id =

        crypto.randomUUID
          ? crypto.randomUUID()
          : Date.now().toString();

      setNotifications(prev => [

        {

          id,

          duration:8000,

          createdAt:Date.now(),

          ...notification

        },

        ...prev

      ]);

    }, []);

  useEffect(() => {

    const originalAlert = window.alert;

    const showVexaAlert = value => {
      let message = "";

      if (typeof value === "string") {
        message = value;
      } else {
        try {
          message = JSON.stringify(value, null, 2);
        } catch {
          message = String(value ?? "");
        }
      }

      message = (message || "Ocurrió algo que requiere tu atención.").trim();

      const normalized = message.toLocaleLowerCase("es-MX");
      const isSuccess = /correctamente|con éxito|guardad[oa]|actualizad[oa]|registrad[oa]|cread[oa]|enviad[oa]/i.test(normalized);
      const isError = /error|no fue posible|no se pudo|falló|fallo|fallida|fallido|promesa:|event error:/i.test(normalized);
      const isWarning = !isSuccess && !isError && /no se encontró|completa |debes |escribe |selecciona |falta |no tiene/i.test(normalized);
      const tone = isError ? "error" : isSuccess ? "success" : isWarning ? "warning" : "info";

      notify({
        source: "vexa-alert",
        tone,
        title: tone === "error"
          ? "No pudimos completar la acción"
          : tone === "success"
            ? "Acción completada"
            : tone === "warning"
              ? "Revisa este detalle"
              : "Aviso del consultorio",
        message: message.replace(/^(PROMESA:|EVENT ERROR:)\s*/i, ""),
        duration: tone === "error" ? 9000 : 6500
      });
    };

    window.alert = showVexaAlert;

    return () => {
      if (window.alert === showVexaAlert) {
        window.alert = originalAlert;
      }
    };

  }, [notify]);

  const value =
    useMemo(

      () => ({

        notify,

        removeNotification,

        clearNotifications

      }),

      [

        notify,

        removeNotification,

        clearNotifications

      ]

    );

  return (

    <NotificationContext.Provider
      value={value}
    >

      {children}

      <NotificationCenter

        notifications={
            notifications
        }

        removeNotification={
            removeNotification
        }

      />

      <VexaDialogHost />

    </NotificationContext.Provider>

  );

}

export function useNotifications() {

  const context =
    useContext(
      NotificationContext
    );

  if (!context) {

    throw new Error(

      "useNotifications debe utilizarse dentro de NotificationProvider."

    );

  }

  return context;

}
